/**
 * Returns an array of class names as a string. Filters out null, undefined, and boolean values.
 * @param classNames The array of class names.
 * @returns A string with all valid class names separated by a space.
 */
export const classNames = (classNames: Array<string | null | undefined | boolean> = []): string => {
    return classNames.filter(c => !!c && !(typeof c === "boolean")).join(" ");
};
